import { Button } from "components/ui_new/index";

export const CancelButton = ({
  isSmallScreen,
  translate,
  setEditMode,
  buttonRef,
  editButtonRef,
  focusEditButton,
  formProps,
  editMode
}) => {
  return (
    <Button
      ref={buttonRef}
      style={
        isSmallScreen
          ? { width: "100%" }
          : { width: "100%", maxWidth: "15rem", minWidth: "10rem" }
      }
      variant="outlined"
      color="primary"
      id="cancel-button"
      type="button"
      onClick={() => {
        formProps.resetForm();
        setEditMode(false);
        if (isSmallScreen) {
          focusEditButton(editButtonRef);
        }
      }}
      onKeyDown={e => {
        if ((e.key === "Enter" || e.key === " ") && isSmallScreen) {
          e.preventDefault();
          formProps.resetForm();
          setEditMode(false);
          focusEditButton(editButtonRef);
        }
      }}
      tabIndex={isSmallScreen ? 0 : (editMode ? 0 : -1)}
    >
      {translate("cancel")}
    </Button>
  );
};

export const SaveButton = ({
  formProps,
  isSmallScreen,
  translate,
  showValidationErrors,
  buttonRef,
  selectedTab,
  editMode
}) => {
  return (
    <Button
      ref={buttonRef}
      style={
        isSmallScreen
          ? { width: "100%" }
          : { width: "100%", maxWidth: "15rem", minWidth: "10rem" }
      }
      variant="contained"
      color="primary"
      id="save-button"
      type="button"
      onClick={async () => {
        const allTouchedFields = {
          patient_information: {
            first_name: true,
            last_name: true,
            email: true,
            phone_number: true,
            mobile_number: true,
            home_address: {
              street_address: true,
              city: true,
              state: true,
              zip: true
            },
            speaks_spanish: true
          },
          physician_information: {
            name: true,
            phone: true,
            fax: true,
            address: {
              street_address: true,
              city: true,
              state: true,
              zip: true
            }
          },
          patient_insurances: true
        };

        formProps.setTouched(allTouchedFields);

        const errors = await formProps.validateForm();

        if (Object.keys(errors).length === 0) {
          formProps.submitForm();
          if (isSmallScreen) {
            setTimeout(() => {
              const selectedTabElement = document.querySelector(
                `#profile-tab-${selectedTab}`
              );
              if (selectedTabElement) {
                selectedTabElement.focus();
              }
            }, 100);
          }
        } else {
          showValidationErrors(errors, formProps.setFieldTouched);
        }
      }}
      disabled={formProps.isSubmitting}
      tabIndex={isSmallScreen ? 0 : (editMode ? 0 : -1)}
    >
      {formProps.isSubmitting ? translate("saving") : translate("save")}
    </Button>
  );
};

export const ButtonActions = ({
  formProps,
  editMode,
  isSmallScreen,
  translate,
  setEditMode,
  handleKeyDown,
  showValidationErrors,
  floatRight,
  saveButtonRef,
  cancelButtonRef,
  editButtonRef,
  focusFirstFormElement,
  focusEditButton,
  selectedTab
}) => {
  return (
    <>
      {editMode ? (
        <div
          className={` ${
            floatRight
              ? "profile-actions-buttons-float-right"
              : "profile-actions-buttons"
          }`}
        >
          {isSmallScreen ? (
            <>
              <SaveButton
                formProps={formProps}
                isSmallScreen={isSmallScreen}
                translate={translate}
                showValidationErrors={showValidationErrors}
                buttonRef={saveButtonRef}
                selectedTab={selectedTab}
                editMode={editMode}
              />
              <CancelButton
                isSmallScreen={isSmallScreen}
                translate={translate}
                setEditMode={setEditMode}
                buttonRef={cancelButtonRef}
                editButtonRef={editButtonRef}
                focusEditButton={focusEditButton}
                formProps={formProps}
                editMode={editMode}
              />
            </>
          ) : (
            <>
              <CancelButton
                isSmallScreen={isSmallScreen}
                translate={translate}
                setEditMode={setEditMode}
                buttonRef={cancelButtonRef}
                editButtonRef={editButtonRef}
                focusEditButton={focusEditButton}
                formProps={formProps}
                editMode={editMode}
              />
              <SaveButton
                formProps={formProps}
                isSmallScreen={isSmallScreen}
                translate={translate}
                showValidationErrors={showValidationErrors}
                buttonRef={saveButtonRef}
                selectedTab={selectedTab}
                editMode={editMode}
              />
            </>
          )}
        </div>
      ) : (
        <div
          className={` ${
            floatRight
              ? "profile-actions-buttons-float-right"
              : "profile-actions-buttons"
          }`}
        >
          <Button
            ref={editButtonRef}
            style={
              isSmallScreen
                ? { width: "100%" }
                : {
                    width: "100%",
                    maxWidth: "15rem",
                    minWidth: "10rem",
                    flex: 1
                  }
            }
            variant="contained"
            color="primary"
            id="edit-button"
            type="button"
            onClick={() => {
              setEditMode(true);
              focusFirstFormElement();
            }}
            onKeyDown={e => {
              handleKeyDown(e);
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setEditMode(true);
                focusFirstFormElement();
              }
            }}
            tabIndex={0}
          >
            {translate("edit")}
          </Button>
        </div>
      )}
    </>
  );
};
